import { useEffect, useState } from 'react';
import { cn } from './cn';
import type { ToastOptions, ToastVariant } from './feedback';

interface ToastItem extends ToastOptions {
  id: number;
  variant: ToastVariant;
}

const variants: Record<ToastVariant, string> = {
  success: 'border-success bg-success/15 text-text',
  error: 'border-danger bg-danger/12 text-text',
  info: 'border-border/40 bg-white text-text',
  warning: 'border-accent bg-accent/12 text-text',
};

export const ToastViewport = () => {
  const [toasts, setToasts] = useState<Array<ToastItem>>([]);

  useEffect(() => {
    const handleToast = (event: Event) => {
      const detail = (event as CustomEvent<ToastOptions>).detail;
      const id = Date.now() + Math.random();
      const toast: ToastItem = {
        id,
        variant: detail.variant || 'info',
        duration: detail.duration ?? 4000,
        ...detail,
      };

      setToasts((current) => [...current, toast]);
      window.setTimeout(() => {
        setToasts((current) => current.filter((item) => item.id !== id));
      }, toast.duration);
    };

    window.addEventListener('app:toast', handleToast);
    return () => window.removeEventListener('app:toast', handleToast);
  }, []);

  return (
    <div className="fixed z-[70] grid gap-2 top-4 right-4 w-[min(420px,calc(100vw-2rem))]">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            'rounded-control border px-4 py-3 text-sm font-medium shadow-[var(--shadow-elevated)] backdrop-blur',
            variants[toast.variant]
          )}
        >
          {toast.title && <p className="mb-1 font-semibold">{toast.title}</p>}
          <p className="text-muted">{toast.message}</p>
        </div>
      ))}
    </div>
  );
};
